<section class="flex flex-col w-full max-w-5xl mx-auto px-2 sm:px-3 gap-6 min-w-0 overflow-x-hidden">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-800">Surveillance</h1>
      <p class="text-sm text-gray-600 mt-1">Suivez d’autres SIREN et consultez leurs annonces récentes.</p>
    </div>
    <button type="button" (click)="sync()" [disabled]="syncing()"
            class="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-3 py-2.5 sm:py-2 text-sm bg-secondary text-white rounded-md hover:bg-secondary-hover disabled:opacity-60 cursor-pointer shrink-0">
      <lucide-icon [name]="RefreshCw" size="16" [class.animate-spin]="syncing()"></lucide-icon>
      Synchroniser
    </button>
  </div>

  <div class="bg-white rounded-md shadow-xl border border-gray-100 p-4 sm:p-6 space-y-4 min-w-0">
    <h2 class="text-lg font-semibold text-gray-800">Ajouter un SIREN</h2>
    <div class="flex flex-col sm:flex-row gap-2">
      <input [(ngModel)]="newSiren" placeholder="SIREN (9 chiffres)" class="flex-1 min-w-0 border border-gray-300 rounded px-3 py-2 text-sm" />
      <input [(ngModel)]="newName" placeholder="Nom (optionnel)" class="flex-1 min-w-0 border border-gray-300 rounded px-3 py-2 text-sm" />
      <button type="button" (click)="add()" class="inline-flex items-center justify-center gap-2 px-4 py-2.5 sm:py-2 bg-gray-800 text-white text-sm rounded-md hover:bg-gray-900 cursor-pointer shrink-0">
        <lucide-icon [name]="Plus" size="16"></lucide-icon>
        Ajouter
      </button>
    </div>
  </div>

  <div class="bg-white rounded-md shadow-xl border border-gray-100 overflow-hidden min-w-0">
    <div class="px-4 py-3 border-b border-gray-100 font-semibold text-gray-800">Sociétés suivies</div>
    <ul class="divide-y divide-gray-100">
      @for (w of watched(); track w.id) {
        <li class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-4 py-3">
          <div class="min-w-0">
            <span class="font-mono text-sm">{{ w.watchedSiren }}</span>
            @if (w.companyName) {
              <span class="text-gray-600 ml-2 text-sm break-words">{{ w.companyName }}</span>
            }
          </div>
          <button type="button" (click)="remove(w)" class="self-start sm:self-auto text-red-500 hover:text-red-700 inline-flex items-center gap-1 cursor-pointer text-sm">
            <lucide-icon [name]="Trash2" size="16"></lucide-icon>
            Retirer
          </button>
        </li>
      } @empty {
        <li class="px-4 py-6 text-center text-gray-500 text-sm">Aucune société suivie.</li>
      }
    </ul>
  </div>

  <div class="min-w-0">
    <h2 class="text-lg font-semibold text-gray-800 mb-3">Dernières annonces (sociétés suivies)</h2>
    <div class="space-y-2">
      @for (a of filteredAlerts(); track a.id) {
        <div class="bg-white rounded-lg border border-gray-100 p-4 shadow-sm">
          <div class="flex items-start gap-3">
            <lucide-icon [name]="FileText" size="18" class="text-gray-500 shrink-0"></lucide-icon>
            <div class="min-w-0">
              <p class="text-xs text-gray-500 mb-1 break-words">
                {{ a.dateParution | date: 'dd/MM/yyyy' }} · SIREN {{ a.siren }}
                @if (a.familleAvis) {
                  <span class="ml-2 px-1.5 py-0.5 rounded bg-gray-100">{{ a.familleAvis }}</span>
                }
              </p>
              <p class="text-sm text-gray-800 break-words">{{ a.description }}</p>
            </div>
          </div>
        </div>
      } @empty {
        <p class="text-sm text-gray-500">Aucune annonce pour les SIREN suivis. Synchronisez après avoir ajouté des sociétés.</p>
      }
    </div>
  </div>
</section>
